import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CircularProgress from '@material-ui/core/CircularProgress';

import * as actionCreators from "../../Action/Tenant/Documents";

import FetchDocument from './FetchDocument'

import AddDocuments from './AddDocuments'

import '../../Styles/ProjectDocuments.scss'

class Documents extends Component {

  constructor(props){
    super(props)
    
  }


static getDerivedStateFromProps (nextProps, prevState) {
  const token =
        secureLocalStorage.getItem("loggedClient") == "user"
          ? secureLocalStorage.getItem("userKey")
          : secureLocalStorage.getItem("tenantKey");
const loggedClient=secureLocalStorage.getItem("loggedClient");
    if (nextProps.DocumentDataFailure != null){
      let key = secureLocalStorage.getItem("tenantKey")
      nextProps.history.push(`/${loggedClient}/${token}`)
      // secureLocalStorage.clear()
      return{null: nextProps.actions.DocumentDataFailure(null)}
    }
    return null
}

 

render(){
    let tenantKey = secureLocalStorage.getItem("tenantKey")
    
    const { loaderStatus } = this.props

    return (
        <div className="documentCont">
            <div className="uploadDocsCont">
                <AddDocuments type = {this.props.match.params.type} id = {this.props.match.params.id}/>
                <div className="tableCont">
                    <div className="card">
                        <div className="docCard">
                            <div className="gridBox">
                                <div className="gridHeader">
                                    <div className="d-flex align-items-center">
                                       <h4>Documents</h4>
                                        {/* <div className="ml-auto">
                                            <div className="searchBox">
                                                 <span className="searchIcon">
                                                    <img src={Images.SEARCHICON} width="12" alt="Search" />
                                                  </span>
                                                  <input type="text" placeholder="Search" name="search"/>
                                            </div>
                                        </div>  */}
                                    </div>
                                </div>
                                <div className="tblCont">
                                    {/* SPINNER */}
                                    { loaderStatus ? <span className="MatTableSpinner">
                                        <CircularProgress style={{'color': '#FFFFFF'}} size={70}/>
                                    </span> : null }
                                    <div className="ag-theme-alpine">
                                        <FetchDocument type = {this.props.match.params.type} id = {this.props.match.params.id}/>
                                    </div>                                
                                </div>
                            </div>  
                        </div>   
                    </div>
                </div>                  
            </div>
        </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch),
});


const mapStateToProps = state => {
  return ({
    loaderStatus: state.Documents.loaderStatus,
    documentDataFailure: state.Documents.documentDataFailure
  });
}
export default connect(mapStateToProps, mapDispatchToProps)(Documents);

